interface ScrollState {
  completionPercentage: number;
}

const SELECTOR = {
  main: ".js-rolodex",
  itemsContainer: ".js-rolodex-item-container",
  itemScroller: ".js-rolodex-item-scroller",
  item: ".js-rolodex-item",
};

const getScrollState = (): ScrollState => ({
  completionPercentage: 0,
});

const calculateCompletionPercentage = (
  $el: HTMLElement,
  verticalOffsetEnd: number = 0,
): number => {
  const start = $el.offsetTop;
  const end = $el.offsetTop + $el.clientHeight - verticalOffsetEnd;

  if (window.scrollY < start) {
    return 0;
  }

  if (window.scrollY > end) {
    return 100;
  }

  const totalScrollDistance = end - start;
  const currentScrollDistance = window.scrollY - start;

  return Math.floor((currentScrollDistance / totalScrollDistance) * 100);
};

const updateAnimationState = ($el: HTMLElement, scrollState: ScrollState) => {
  const itemContainer = $el.querySelector(SELECTOR.itemsContainer);
  const itemScroller = $el.querySelector(SELECTOR.itemScroller);
  const items = $el.querySelectorAll(SELECTOR.item);
  const item = $el.querySelector(SELECTOR.item);

  if (!itemContainer || !itemScroller || !items || !item) {
    return;
  }

  scrollState.completionPercentage = calculateCompletionPercentage(
    $el,
    itemContainer?.clientHeight * 1.5,
  );

  if (
    itemScroller instanceof HTMLElement &&
    scrollState.completionPercentage >= 0 &&
    scrollState.completionPercentage <= 100
  ) {
    // Set scroll position
    const itemsTransformRange =
      itemScroller.clientHeight - itemContainer.clientHeight;
    itemScroller.style.transform = `translateY(-${
      (scrollState.completionPercentage / 100) * itemsTransformRange
    }px)`;
  }
};

const instance = ($el: HTMLElement, scrollState: ScrollState) => {
  const rolodex = $el.querySelector(SELECTOR.main);

  if (!rolodex) {
    return;
  }

  window.addEventListener("scroll", () => {
    updateAnimationState($el, scrollState);
  });

  updateAnimationState($el, scrollState);
};

const rolodex = () => {
  document.querySelectorAll(SELECTOR.main).forEach(($el: Element) => {
    const scrollState = getScrollState();
    const $parent = $el.closest(".section") as HTMLElement;

    if (!$parent) {
      return;
    }

    instance($parent, scrollState);
  });
};

export default rolodex;
